import { useEffect, useState } from "react";
import i18n from "../../../lib/i18n";
import AddPagesUi from "../../../ui/pages/addPages";
import { GetPagesData } from "../../../lib/data";
import AddPagesSectionUi from "../../../ui/pageSectionUi/addPageSection";

export default function AddPagesSection() {

    const [pagesData, setPagesData] = useState([]);
    const t = i18n.t.bind(i18n); 

    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const pageData = await GetPagesData();
        setPagesData([]);
        pageData.data.map((e) => setPagesData((prev) => [...prev, e]));
    };

    const search = async (param) => {
        const params = [ {"name": param} ];
        if(param){
            const pageDataFilter = await GetPagesData(1,params);
            setPagesData([]);
            pageDataFilter.data.map((e) => setPagesData((prev) => [...prev, e]));
        }
    };

    return (
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("add_page_title.page")} </h1>
                <AddPagesSectionUi search={search} pagesData={pagesData} />
            </div>
        </div>
    );
};